import { ContentService, PortfolioService, DavisAlertService } from "@DavisDigital/davisdigitalfrontend.module";

class PortfolioAdministerShareModalController {
    
    private close:Function; //injected from modal-service
    public baseObject:any;
    public title:string;
    public isLoading:boolean = false;
	
	public districtAccounts:Array<any> = [];
	public portfolioFacultyAccount:string = "";
	
	// @ngInject
	constructor(
		public contentService   : ContentService,
		public portfolioService : PortfolioService,
		public davisAlertService: DavisAlertService
	){}
	
	public $onInit = () => {
        //initialize properties
        this.title = this.baseObject.title;
        this.loadDistrictAccounts();
	}
	
	private loadDistrictAccounts = () => {
		this.contentService.getAccountsListForShare({shareWithoutAccessOnly: true, ignoreStudentAccounts: true, ignoreAdminAccounts: false}).then( (response)=>{
			this.districtAccounts = response.data.accountsWithoutAccess;
		});
	}
	
	
	public onCloseModal = () =>{
		this.close();
	}
	
	public onSubmitShare = () => {
		
		//return if isLoading is already true (it means another call is in process)
		if(this.isLoading){
			return;
		}
		//set isLoading to true (to prevent any other API call)
		this.isLoading = true;
		
		this.portfolioService.assignAdministratorToPortfolio(this.baseObject.portfolioID, this.portfolioFacultyAccount).then( (response)=>{ 
			
			console.log(response);
			if( response.successfulActions.length ) {
				this.davisAlertService.success("Portfolio Has been shared.");
				this.onCloseModal();
			} else {
				if( response.data.message != "" ) {
					this.davisAlertService.error(response.data.message);
				} else {
					this.davisAlertService.error("Error in sharing portfolio.");
				}
			}
			
			
		}).finally(() => {
			this.isLoading = false;
		});
		
	}

}
    

class PortfolioAdministerShareModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    baseObject: "<",
		close:'='
	};

	public controller = PortfolioAdministerShareModalController;
	public controllerAs = 'portfolioAdministerShareModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/portfolio-administer-share-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { PortfolioAdministerShareModal };
